/**
 * AI 어시스턴트 & 지식 베이스 페이지
 */

import React, { useState } from 'react';
import { KnowledgeProvider } from '../contexts/KnowledgeContext';
import { SecureNotesProvider } from '../contexts/SecureNotesContext';
import { Terminal } from '../components/Assistant';
import { KnowledgePanel } from '../components/Knowledge';
import './KnowledgePage.css';

function KnowledgePage() {
  const [showKnowledgePanel, setShowKnowledgePanel] = useState(false);

  return (
    <SecureNotesProvider>
      <KnowledgeProvider>
        <div className="assistant-page">
          {/* 메인 터미널 */}
          <div className="assistant-main">
            <Terminal onClose={() => window.history.back()} />
          </div>

          {/* 지식 베이스 사이드 패널 */}
          <button
            className="knowledge-toggle-btn"
            onClick={() => setShowKnowledgePanel(!showKnowledgePanel)}
          >
            {showKnowledgePanel ? '📚 ✕' : '📚 지식'}
          </button>

          {showKnowledgePanel && (
            <div className="knowledge-sidebar">
              <KnowledgePanel />
            </div>
          )}
        </div>
      </KnowledgeProvider>
    </SecureNotesProvider>
  );
}

export default KnowledgePage;
